import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'sortByField',
    standalone: true
})
export class SortByFieldPipe implements PipeTransform {

    // transform(items: any[], field: string): any[] {
    //     if (!items || !field) return items;
    //     console.log(field.toLowerCase())
    //     if (field.toLowerCase().includes('ar')) {
    //         return [...items].sort((a, b) => {
    //             const aVal = (a[field] || '').toString().trim();
    //             const bVal = (b[field] || '').toString().trim();
    //             return aVal.localeCompare(bVal, 'ar'); // Simplified options
    //         });
    //     }
    //     else {
    //         return [...items].sort((a, b) =>
    //             (a[field] || '').toString().localeCompare((b[field] || '').toString(), 'en')
    //         );
    //     }
    // }
    transform(data: any[], key: string): any[] {
        if (!Array.isArray(data) || !key) return [];

        const collator = new Intl.Collator('ar', { sensitivity: 'base' });

        const normalizeArabicString = (str: string): string => {
            return (str || '')
                .replace(/[\u064B-\u065F]/g, '') // Remove harakat (diacritics)
                .replace(/[إأآ]/g, 'ا')          // Normalize Alef variants to ا
                .replace(/^ال/, '')              // Remove definite article *after* Alef normalization
                .replace(/ة/g, 'ه')              // Ta Marbuta to Ha
                .replace(/ى/g, 'ي')              // Alef Maqsura to Ya
                .trim();
        };

        const sorted = [...data].sort((a, b) => {
            const aVal = normalizeArabicString(a?.[key]);
            const bVal = normalizeArabicString(b?.[key]);
            return collator.compare(aVal, bVal);
        });
        //  console.log('Sorted Arabic array:', sorted);
        return sorted;
    }




}
